import analytics from './mixpanel';

export const trackRatingDialogShown = (daysSinceCreation: number) => {
  analytics.track('rating_dialog_shown', {
    days_since_creation: daysSinceCreation,
  });
};

export const trackRatingSubmitted = (rating: number) => {
  analytics.track('rating_submitted', {
    rating,
    timestamp: new Date().toISOString(),
  });
};

export const trackRatingRemindLater = () => {
  analytics.track('rating_remind_later', {
    timestamp: new Date().toISOString(),
  });
};
